import { type ComponentProps } from 'react';

export type ShortcutInfoProps = ComponentProps<'div'>;

export const ShortcutInfo = ({ children, ...props }: ShortcutInfoProps) => {
  return (
    <div
      className="pointer-events-none flex min-h-[20px] w-fit min-w-[20px] items-center justify-center rounded-4 ads:bg-raised bg-gray-2 px-1 ads:text-secondary text-12 text-gray-11 uppercase"
      {...props}
    >
      {children}
    </div>
  );
};
